export default {"src":"/_next/static/image/public/images/flags/flag_382.047dd5f1951cd1e3e08243f9038d058a.svg","height":16,"width":24};